/*
This class takes a string of html and a rootNode - it will return a valid HTMLElement
You can optionally pass in an object where any valid dot notation found
within curly braces {{ }} in the html string will be replaced
 */
export const partial = (html: string, rootNode?: string): HTMLElement => {
  const converter = document.createElement('div') as HTMLElement;
  converter.innerHTML = html;

  return rootNode ? converter.querySelector(rootNode) : converter.firstElementChild;
};
